import axios from "axios";

import { clearPreferredPortal } from "@/lib/portals";

export const AUTH_TOKEN_KEY = "authToken";

export const setToken = (token: string): void => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const getToken = (): string | null => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

export const removeToken = (): void => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  clearPreferredPortal();
};

/** Token a failed axios request was sent with, or null if it had none. */
export const tokenFromError = (err: unknown): string | null => {
  if (!axios.isAxiosError(err)) return null;
  const header = err.config?.headers?.Authorization;
  if (typeof header !== "string") return null;
  return header.replace(/^Token\s+/, "") || null;
};

export const isUnauthorized = (err: unknown): boolean =>
  axios.isAxiosError(err) && err.response?.status === 401;
